<template>
  <v-layout v-if="item && comments" row justify-center>
    <v-dialog v-model="dialog" fullscreen transition="dialog-bottom-transition" :overlay=false>
      <v-card class="grey pt-5">
        <v-toolbar fixed>
          <v-toolbar-title class="flex xs12">
            <v-flex class=" offset-md2 md8">{{item.headline}}</v-flex>
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn icon @click.native="$emit('update:dialog', false); $router.push({path: '/' })" title="close">
              <v-icon>close</v-icon>
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <v-layout v-if="dialog" row wrap mt-5>
          <v-flex xs12 md8 offset-md2 mt-4 mb-4>
            <v-card>
              <v-card-text class="pa-0">
                <v-flex xs12 text-xs-center grey lighten-2 elevation-1>
                  <img v-if="item.path !== '.'" class="responsive-img text-xs-center"
                       :src="$helper.getLocation()+item.path">
                </v-flex>
                <v-flex xs12 px-5 pt-1>
                  <v-layout row wrap>
                    <v-dialog v-model="loginHintVis" width="400" light>
                      <v-card light>
                        <v-card-title class="indigo white--text ">Nicht Eingeloggt!</v-card-title>
                        <v-card-text>Bitte schließe den Artikel und klicke oben rechts auf den Login-Button, um News zu liken und zu kommentieren.</v-card-text>
                        <v-card-actions><v-spacer></v-spacer>
                          <v-btn color="indigo darken-1"  flat @click.native="toggleLoginHint()">OK</v-btn></v-card-actions></v-card></v-dialog>
                    <v-badge bottom :overlap="true"
                             :title="activeUser.id ? 'Like' : 'Please login on the top right to like this item.'"
                             class="ml-4 small-badge" :class="activeUser.id ? 'cursor-pointer highlight' : ''"
                             @click.native="activeUser.id ? like({item,val:'like', user_id: activeUser.id}) : toggleLoginHint('like')">
                      <span slot="badge" class="small">{{item.likes.split(',').length - 1}}</span>
                      <v-icon class="text-elevation-5" medium
                              :color="item.likes.indexOf(activeUser.id)>-1 ? 'blue darken-3' : 'blue lighten-3'">
                        thumb_up
                      </v-icon>
                    </v-badge>
                    <v-badge bottom :overlap="true"
                             :title="activeUser.id ? 'Mark as favorite' : 'Please login on the top right to like this item.'"
                             class="small-badge" :class="activeUser.id ? 'cursor-pointer highlight' : ''"
                             @click.native="activeUser.id ? like({item,val:'favorite', user_id: activeUser.id}) : toggleLoginHint('favorite')">
                      <span slot="badge">{{item.likes_favorite.split(',').length - 1}}</span>
                      <v-icon class="text-elevation-5" medium
                              :color="item.likes_favorite.indexOf(activeUser.id)>-1 ? 'red darken-3' : 'red lighten-3'">
                        favorite
                      </v-icon>
                    </v-badge>
                  </v-layout>
                </v-flex>
                <v-flex xs12 px-5 py-3 md11 offset-md1 class="word-break">
                  <div v-html="item.long_text"></div>
                </v-flex>
                <v-flex v-if="userById[item.user_id]" xs12 text-xs-right pa-3>
                  <img class="icon btn--round elevation-8 center-cropped-50 white"
                       :src="$helper.getLocation()+userById[item.user_id].img">
                </v-flex>
              </v-card-text>
            </v-card>
          </v-flex>
          <v-flex xs12 md8 offset-md2 mb-5>
            <comments-dialog v-if="activeUser.id" :activeUser="activeUser" :news_item="item"></comments-dialog>
            <v-card v-for="(comment,key) in comments" :key="key" class="mt-2 elevation-3">
              <v-card-title class="pr-5 py-3 grey lighten-1 elevation-inset-2">
                <v-layout row>
                  <v-flex xs10>
                    <v-icon class="left mr-4" medium>comment</v-icon>
                    <h3 class="mt-3">{{comment.headline}}</h3>
                  </v-flex>
                  <v-flex xs2 v-if="userById[item.user_id]">
                    <img class="icon btn--round elevation-3 center-cropped-50 right white"
                         :src="$helper.getLocation()+userById[comment.user_id].img">
                  </v-flex>
                </v-layout>
                <v-flex xs12>
                  <v-layout row wrap>
                    <v-badge bottom :overlap="true"
                             :title="activeUser.id ? 'Like' : 'Please login on the top right to like this item.'"
                             class="ml-4 small-badge" :class="activeUser.id ? 'cursor-pointer highlight' : ''"
                             @click.native="activeUser.id ? likeComment({comment,val:'like', user_id: activeUser.id, news_id: item.id}) : toggleLoginHint('like')">
                      <span slot="badge" class="small">{{comment.likes.split(',').length - 1}}</span>
                      <v-icon class="text-elevation-5" medium
                              :color="comment.likes.indexOf(activeUser.id)>-1 ? 'blue darken-3' : 'blue lighten-3'">
                        thumb_up
                      </v-icon>
                    </v-badge>
                    <v-badge bottom :overlap="true"
                             :title="activeUser.id ? 'Mark as favorite' : 'Please login on the top right to like this item.'"
                             class="small-badge" :class="activeUser.id ? 'cursor-pointer highlight' : ''"
                             @click.native="activeUser.id ? likeComment({comment,val:'favorite', user_id: activeUser.id, news_id: item.id}) :  toggleLoginHint('favorite')">
                      <span slot="badge">{{comment.likes_favorite.split(',').length - 1}}</span>
                      <v-icon class="text-elevation-5" medium
                              :color="comment.likes_favorite.indexOf(activeUser.id)>-1 ? 'red darken-3' : 'red lighten-3'">
                        favorite
                      </v-icon>
                    </v-badge>
                  </v-layout>
                </v-flex>
              </v-card-title>
              <v-card-text class="px-5 py-3">
                {{comment.text}}
              </v-card-text>
            </v-card>
          </v-flex>
        </v-layout>
      </v-card>
    </v-dialog>
  </v-layout>
</template>
<script>
  /* eslint-disable object-shorthand */

  // eslint-disable-next-line import/extensions
  import {mapGetters, mapActions} from 'vuex';
  import ConfirmModal from '../general/Modal/ConfirmModal';
  import CommentsDialog from "./CommentsDialog";

  export default{
    components: {
      CommentsDialog,
      ConfirmModal,
    },
    name: 'full-article',
    props: ['dialog'],
    computed: {
      ...mapGetters(['userById', 'activeUser', 'activeComments', 'activeArticle']),
      comments() {
        return this.activeComments;
      },
      item() {
        return this.activeArticle;
      },
    },
    watch: {
      "$route" (to, from) {
        if (to.path === '/') {
            this.$emit('update:dialog', false);
          this.setActiveArticle({});
        }
      },
    },
    data () {
      return {
        search: '',
        deleteSuccess: false,
        notifications: false,
        sound: true,
        widgets: false,
          loginHintVis: false,
      };
    },
    methods: {
      ...mapActions(['likeNews', 'updatePoints', 'likeNewsComment', 'setActiveArticle']),
      deleteComment(id) {
        // console.log(this.$helper.apiUrl()+'/content/news/' + this.id + '/comments/' + id)
        this.$http.delete(this.$helper.apiUrl()+'/content/news/' + this.id + '/comments/' + id).then(resp => {
          this.getComments();
        });
      },
      getComments() {
        this.$http.get(this.$helper.apiUrl()+'/content/news/' + this.item.id + '/comments').then(resp => {
          // console.log(resp.body);
          this.comments = resp.body;
        });
      },
      fullName (user) {
        return user.userName + ': ' + user.firstName + ' ' + user.lastName;
      },
      like({item, val, user_id}) {
        this.toggleLike = true;
        this.likeNews({item, val, user_id, cb: this.updatePoints});
          ga('send', {
              hitType: 'event',
              eventCategory: val === 'favorite' ? 'favoriteBtn' : 'likeBtn',
              eventAction: 'like',
              eventLabel: 'like',
              eventValue: 200
          });
      },
        toggleLoginHint(val){
            this.loginHintVis = !this.loginHintVis
            ga('send', {
                hitType: 'event',
                eventCategory: val === 'favorite' ? 'favoriteBtn' : 'likeBtn',
                eventAction: 'like',
                eventLabel: 'like_attempt',
                eventValue: 50
            });
        },
      likeComment({comment, val, user_id, news_id}) {
        // console.log('likeComment ', comment)
        this.likeNewsComment({comment, val, user_id, cb: this.updatePoints, news_id});
          ga('send', {
              hitType: 'event',
              eventCategory: val === 'favorite' ? 'favoriteBtn' : 'likeBtn',
              eventAction: 'like',
              eventLabel: 'like',
              eventValue: 200
          });
      },
    },
    mounted() {
      //this.getComments();
    },
  };
</script>
